import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.span`
  cursor: pointer;
  position: relative;
  display: inline-block;
  border-bottom: ${props =>
    props.underline &&
    '1px dotted black'}; /* If you want dots under the hoverable text */
`;

const Icon = styled.span`
  align-items: center;
  background-color: ${props => props.theme.carvana.blue.primary};
  border-radius: 50%;
  color: white;
  display: flex;
  height: .9rem;
  font-size: 0.8rem;
  justify-content: center;
  text-align: center;
  width: .9rem;
`;

const QuestionMark = styled.span``;

const Text = styled.span`
  color: white;
  position: absolute;
  z-index: 1000;
  background-color: ${props => props.color};
  padding: 15px;
  font-size: 0.8rem;
  width: 240px;
  min-height: 30px;
  left: -194px;
  margin-top: 30px;
  border-radius: 3px;
  visibility: hidden;
  text-transform: none;

  @media (min-width: ${props => props.theme.breakpoints.sm}px) {
    left: -126px;
  }

  &::after {
    top: -10px;
    left: 187px;
    border-width: 0 13px 13px;
    content: '';
    position: absolute;
    border-style: solid;
    border-color: ${props => props.color} transparent;
    display: block;
    width: 0;

    @media (min-width: ${props => props.theme.breakpoints.sm}px) {
      left: 120px;
    }
  }

  ${Container}:hover & {
    visibility: visible;
  }
`;

const TooltipNext = ({ customValue, text, color, ...rest }) => (
  <Container {...rest}>
    {customValue || (
      <Icon>
        <QuestionMark>&#63;</QuestionMark>
      </Icon>
    )}
    {text && <Text color={color}>{text}</Text>}
  </Container>
);

TooltipNext.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  customValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
    PropTypes.element
  ]),
  color: PropTypes.string
};

TooltipNext.defaultProps = {
  text: null,
  customValue: null,
  color: '#555555'
};

export default TooltipNext;
